
import CopyLink from './CopyLink';
import Instructions from './Instructions';
import ReferralUser from './ReferralUser';

export const Referral = () => {
    return (
        <>
            <section className="row gy-4 mt-1">
                <CopyLink />
                <Instructions />
                <ReferralUser />
            </section>
        </>
    );
};
